module.exports = __webpack_public_path__ + "media/images/checbox-active-d7cfd2aecd7dbae698bc6c7e992fa412.svg";